const WEBFLOW_SITE = '68f92bd9b64e660d33bc67d7';
const WEBFLOW_PAGE = '68f92bd9b64e660d33bc67bc';

const SCRIPTS = [
  `https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=${WEBFLOW_SITE}`,
  `https://cdn.prod.website-files.com/${WEBFLOW_SITE}/js/webflow.schunk.161f08e56d0294aa.js`,
  `https://cdn.prod.website-files.com/${WEBFLOW_SITE}/js/webflow.87ef7604.9cc7532b5053a389.js`,
] as const;

type WebflowApi = {
  destroy: () => void;
  ready: () => void;
  require: (module: 'ix2') => { init: () => void };
};

declare global {
  interface Window {
    Webflow?: WebflowApi;
    jQuery?: unknown;
  }
}

function loadScript(src: string): Promise<void> {
  const existing = document.querySelector(`script[src="${src}"]`);
  if (existing) return Promise.resolve();

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.body.appendChild(script);
  });
}

function prepareDocument(): void {
  const html = document.documentElement;
  html.setAttribute('data-wf-site', WEBFLOW_SITE);
  html.setAttribute('data-wf-page', WEBFLOW_PAGE);
  html.classList.add('w-mod-js');

  if ('ontouchstart' in window) {
    html.classList.add('w-mod-touch');
  }
}

async function loadScripts(): Promise<void> {
  for (const src of SCRIPTS) {
    await loadScript(src);
  }
}

export async function initWebflowRuntime(): Promise<void> {
  prepareDocument();
  await loadScripts();

  const { Webflow } = window;
  if (!Webflow) return;

  Webflow.destroy();
  Webflow.ready();
  Webflow.require('ix2').init();

  window.dispatchEvent(new Event('resize'));
  requestAnimationFrame(() => window.dispatchEvent(new Event('scroll')));
}

export function destroyWebflowRuntime(): void {
  window.Webflow?.destroy();
}
